/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import StatsBar from '../../Common/StatsBar';
import { getStatsBarData } from '../../../utils/utils';
import ImgCrop from '../../Common/ImgCrop';
import Share from '../../Common/GigyaShare';

const Result = (props) => {
  const { t, data, quizResponse, quizResult, trackButton } = props;

  const [toggle, setToggle] = useState(false);
  const [styleDonut, setStyleDonut] = useState(false);

  useEffect(() => {
    props.getResultAccessibility();
    setStyleDonut(true);
  }, []);

  const toggleSummary = (e) => {
    const element = document.getElementById('resultSec');
    const toggleButton = document.getElementById('quiz-accordian');
    if (element && toggleButton) {
      toggleButton.classList.toggle('button-toggle');
      element.classList.toggle('summary-toggle');
      trackButton(e, 'accordian-btn');
    }
    if (document.getElementById('accResultId').getAttribute('aria-expanded') == 'false') {
      document.getElementById('accResultId').setAttribute('aria-expanded', 'true');
    } else {
      document.getElementById('accResultId').setAttribute('aria-expanded', 'false');
    }
  };

  const answerIconsStats = (response, index) => {
    if (response) {
      if (
        quizResult &&
        quizResult.optionsInfo &&
        quizResult.optionsInfo.length &&
        quizResult.optionsInfo[index] &&
        response.rawitemid_s == quizResult.optionsInfo[index].Id
      ) {
        const status = quizResult.optionsInfo[index].correctAnswer;
        if (status == true) {
          return [
            'icon-check-circle',
            t('YourAnswerIsCorrect') ? t('YourAnswerIsCorrect') : 'Your Answer Is Correct',
          ];
        } else if (status == false) {
          return [
            'icon-x-circle',
            t('YourAnswerIsIncorrect') ? t('YourAnswerIsIncorrect') : 'Your Answer Is Incorrect',
          ];
        }
      }
    }
    return ['', ''];
  };

  const setClass = () => {
    return toggle ? 'social-share__footer isShowStatsBar' : 'social-share__footer';
  };

  const closeShare = (evt) => {
    evt.preventDefault();
    setTimeout(() => {
      setToggle(!toggle);
    }, 1000);
  };

  const openShare = (e) => {
    e.stopPropagation();
    setToggle(!toggle);
  };
  const shareData = getStatsBarData(data);
  shareData.shortheadline_t = quizResult && quizResult.chartobj && quizResult.chartobj.shareText;
  return (
    <div className="grid-12 result">
      <div className="result__summary-screen">
        <div className="img-holder">
          {data &&
            data.BackgroundImage &&
            data.BackgroundImage.value &&
            data.BackgroundImage.value.Crops && (
              <ImgCrop
                imgCrop={data.BackgroundImage.value.Crops}
                singleSrc={false}
                alt=""
                title={data.Title && data.Title.value}
                isWebpAvailable={data.BackgroundImage.value.isWebpAvailable}
              ></ImgCrop>
            )}
        </div>
        <div className="result-wrapper" style={{ position: 'absolute' }}>
          <h2 className="result__title">
            <span>
              {decodeURI(quizResult && quizResult.chartobj && quizResult.chartobj.scoreMessage)}
            </span>
          </h2>
          <p className="result__score">
            {t('YouScored')} {quizResult && quizResult.totalCorrectAnswer} {t('outof')}{' '}
            {quizResult && quizResult.totalQuestion}
          </p>
          <div className="result__graph" aria-hidden="true">
            <svg width="180" height="180" className="donut" viewBox="3 38 31 34">
              <circle
                className="donut-ring-back"
                cx="19"
                cy="55"
                r="15.8"
                fill="transparent"
                stroke="#fff"
                strokeWidth=".5"
              ></circle>
              <circle
                className="donut-ring"
                cx="19"
                cy="55"
                r="15.8"
                fill="transparent"
                stroke="#db1d24"
                strokeWidth="1"
                style={
                  styleDonut
                    ? {
                        strokeDasharray: `${
                          quizResult &&
                          quizResult.chartobj &&
                          quizResult.chartobj.dasharray &&
                          quizResult.chartobj.dasharray.length &&
                          quizResult.chartobj.dasharray[0]
                        } 999`,
                      }
                    : {}
                }
              ></circle>
            </svg>

            {quizResult && quizResult.totalQuestion && (
              <div direction="ltr" className="passing-percentage">
                {quizResult.totalCorrectAnswer}/{quizResult.totalQuestion}
              </div>
            )}
          </div>
          <div className="result-buttons">
            <div
              className="white-btn-skew-v2 share-button quiz-share-to-friend"
              role="button"
              tabIndex="0"
              title={quizResult && quizResult.chartobj && quizResult.chartobj.shareText}
              onClick={(e) => {
                trackButton(e, 'share-btn');
                openShare(e);
              }}
            >
              <span className="red-btn-skew-link">
                {t('ChallengeAFriend') ? t('ChallengeAFriend') : 'Challenge a friend'}
              </span>
              <span className="statsbar" aria-hidden="false">
                <span>
                  <span className="modalShareLink" id="modalShareLink">
                    <span
                      aria-label={t('Share') ? t('Share') : 'share'}
                      title={data.Title && data.Title.value}
                      onClick={(e) => e.stopPropagation()}
                    ></span>
                  </span>
                </span>
              </span>
              {toggle && (
                <div
                  role="dialog"
                  data-test="share-container"
                  className={setClass()}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Share item={shareData}></Share>
                  <span className="close" onClick={closeShare}>
                    <a href="#!" role="button" aria-label="Close more share options">
                      <i className="icon-close-black" />
                    </a>
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div id="quiz-accordian" className="quiz-accordian">
          <span aria-hidden="true">{t('YourAnswers')}</span>
          <span
            onClick={(e) => {
              toggleSummary(e);
            }}
            onKeyPress={(e) => {
              toggleSummary(e);
            }}
            tabIndex="0"
            role="button"
            aria-expanded="false"
            aria-controls="resultSec"
            id="accResultId"
            className="acc-button"
          >
            <i className="icon-plus-circle">{t('YourAnswers')}</i>
          </span>
        </div>
      </div>
      {/*summary detail*/}
      <div className="summary-screen" id="resultSec" aria-labelledby="accResultId">
        <div className="summry-wrapper">
          <ul>
            {quizResult &&
              quizResult.optionsInfo &&
              quizResponse &&
              quizResponse.map((response, index) => (
                <li key={index}>
                  {t('Q') ? t('Q') : 'Q'}
                  {index + 1}. {response.question_t}
                  {response.optionsDetail_info && !response.optionsDetail_info.isMultiChoice && (
                    <p>
                      {`${t('CorrectAnswer')} `}
                      {response.questionoptions_s &&
                        response.optionsDetail_info &&
                        response.questionoptions_s[
                          response.optionsDetail_info.correctAnswerIndex
                        ] &&
                        response.questionoptions_s[response.optionsDetail_info.correctAnswerIndex]
                          .optionText}
                    </p>
                  )}
                  {response.optionsDetail_info && response.optionsDetail_info.isMultiChoice && (
                    <div>
                      <p>
                        {`${t('CorrectAnswer')} `}
                        {response.optionsDetail_info &&
                          response.optionsDetail_info.correctAnswerIndex &&
                          response.optionsDetail_info.correctAnswerIndex.map((answers, index) => (
                            <i key={index}>
                              {response.questionoptions_s &&
                                response.questionoptions_s[answers] &&
                                response.questionoptions_s[answers].optionText}
                              {index === response.optionsDetail_info.correctAnswerIndex.length - 1
                                ? ' '
                                : ', '}
                            </i>
                          ))}
                      </p>
                    </div>
                  )}
                  <span aria-label={answerIconsStats(response, index)[1]}>
                    <i className={answerIconsStats(response, index)[0]}></i>
                  </span>
                </li>
              ))}
          </ul>
        </div>
      </div>
      <StatsBar item={getStatsBarData(data)} classes="quiz-statsbar" type="quiz"></StatsBar>
    </div>
  );
};
export default withTranslation()(Result);
